import React from 'react'
import { Card, ListGroup } from 'react-bootstrap'
import { RegistrationStatus } from './SuccessStage'

const SuccessRegistrationCard = (props: {
  type: RegistrationStatus
  registrations: string[]
}) => {
  let cssVariant = 'bg-danger'
  let title = 'Achtung: Es ist etwas schiefgelaufen!'

  const { type, registrations } = props

  if (type === RegistrationStatus.YES) {
    cssVariant = 'bg-success text-white'
    title = 'Zugeteilte Anmeldungen'
  } else if (type === RegistrationStatus.MAYBE) {
    cssVariant = 'bg-warning'
    title = 'Anmeldungen auf der Warteliste'
  } else if (type === RegistrationStatus.NO) {
    title = 'Abgelehnte Anmeldungen'
  } else {
    cssVariant = 'bg-info'
    title = 'Eingegangene Anmeldungen'
  }

  return (
    <>
      <Card className='mt-3'>
        <Card.Header className={cssVariant}>{title}</Card.Header>
        <Card.Body>
          <ListGroup variant='flush'>
            {registrations.map((reg, key) => (
              <ListGroup.Item key={key}>
                <Card>
                  <Card.Body>{reg}</Card.Body>
                </Card>
              </ListGroup.Item>
            ))}
          </ListGroup>
        </Card.Body>
      </Card>
      <br />
    </>
  )
}

export default SuccessRegistrationCard
